import { Box, Grid } from "@mui/material";
// import singanls_group from "../../../../../asset/image/signals_group.svg";
import excellent_signal from "../../../../../asset/image/excellent_signal.svg";
import good_signal from "../../../../../asset/image/good_signal.svg";
import fair_signal from "../../../../../asset/image/fair_signal.svg";
import poor_signal from "../../../../../asset/image/poor_signal.svg";

import r_excellent_signal from "../../../../../asset/image/r_excellent_signal.svg";
import r_good_signal from "../../../../../asset/image/r_good_signal.svg";
import r_fair_signal from "../../../../../asset/image/r_fair_signal.svg";
import r_poor_signal from "../../../../../asset/image/r_poor_signal.svg";

import very_poor_signal from "../../../../../asset/image/very_poor_signal.svg";
import no_signal from "../../../../../asset/image/no_signal.svg";
// import singanls_group from "../../../../../asset/image/signals_group.svg";
import outlined_sim_icon from "../../../../../asset/image/outlined_sim_icon.svg";
import fair_grapg from "../../../../../asset/image/fair_graph.svg";
import good_graph from "../../../../../asset/image/good_graph.svg";
import excellent_graph from "../../../../../asset/image/excellent_graph.svg";
import LabelValueDisplay from "../LabelValue/LabelValueDisplay";
import { convertSecondsToUptime, readableBytesFormat } from "../../../../../utils/util";



const SimDetails = ({simData}) => {
    const getSignalStrength = (value) => {
        if (value < 1) return "0";
        if (value < 7) return "1";
        if (value < 10) return "2";
        if (value < 12.6) return "3"; 
        if (value >= 12.6) return "4";
        return "0";
    };

    const getSignalIcon = (roaming, strength) => {
        switch(strength) {
            case "4": return roaming? r_excellent_signal: excellent_signal;
            case "3": return roaming? r_good_signal: good_signal;
            case "2": return roaming? r_fair_signal: fair_signal;
            case "1": return roaming? r_poor_signal: poor_signal;
            default:  return no_signal;
        }
    };

    const getSignalText = (value) => {
        if (value < 7) return "Poor";
        if (value < 10) return "Fair";
        if (value < 12.6) return "Good"; 
        if (value >= 12.6) return "Excellent";
        return "Poor";
    };


    return (
        <Grid style={{border: 'rgba(235, 235, 235, 1)', minHeight:"190px",background:"rgba(248, 247, 247, 1)"}} className="controller-grid" p={1}>
            <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6} className="controller-progress" pt={1}>
                    {
                        simData?.technology?
                        <Box
                        sx={{
                            backgroundColor: "rgba(38, 76, 134, 1)",
                            color: "rgba(255, 255, 255, 1)",
                            fontWeight: 600,
                            fontSize: "12px",
                            lineHeight: "18px",
                            borderRadius: "4px",
                            px: 2,
                            py: 0.5,
                            transition: "all 0.3s ease",
                            padding: '0 8px',
                            height: '20px',
                            fontFamily: 'Inter',
                            width: 'fit-content',
                            textTransform:"uppercase"
                        }}
                    >
                        {simData?.technology || ''}
                    </Box>
                    :""
                    }
                    
                    <img src={getSignalIcon(simData?.roaming, getSignalStrength(simData?.sinr))} alt="" />
                    {simData?.operator && <div className="display-center-align-gap">
                        <img src={outlined_sim_icon} alt="" />
                        <span className="value-text-controller">{simData?.operator || ''}</span>
                    </div>}
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} pt={1} mt={0.5}>
                    <div className="display-center-justify-between">
                        <span style={{fontSize:"14px", fontWeight:"500"}}>{convertSecondsToUptime(simData?.uptime)}</span>
                        <span style={{fontSize:"14px"}}>TX / RX : <span style={{fontSize:"14px", fontWeight:"500"}}>{readableBytesFormat(simData?.txbytes)} / {readableBytesFormat(simData?.rxbytes)}</span></span>
                    </div>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6} mt={2.5}>
                    <Grid container spacing={0.5} pb={0.5}>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                            <LabelValueDisplay
                                label="Priority Mode"
                                value={simData?.status? simData?.status == "auto"? "Auto": "Manual": "--"}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                            <LabelValueDisplay
                                label="Band"
                                value={(simData?.band)?.toUpperCase() || '--'}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>

                            <LabelValueDisplay
                                label="Bandwidth"
                                value={simData?.bandwidth || '--'}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={0.5}>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                            <LabelValueDisplay
                                label="MCC / MNC"
                                value={String(simData?.mccmnc).replace(/(\d{3})(?=\d)/, "$1 / ") || '--'}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                            <LabelValueDisplay
                                label="Cell ID"
                                value={(simData?.cellid)?.toUpperCase() || '--'}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                            <LabelValueDisplay
                                label="PLMN"
                                value={simData?.mccmnc || '--'}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} mt={2.5}>
                    <Grid container spacing={1.5}>
                        {
                            simData.snr &&
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <div>
                                    <LabelValueDisplay
                                        label="SNR"
                                        value={simData?.snr + ` dB (${getSignalText(simData?.snr)})` || '--'}
                                        // flexDirection='row'
                                    />
                                </div>
                            </Grid>
                        }
                        
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SimDetails;